import { useMemo } from 'react';

import { Pesel } from '@dreryk/personal-external-identifier-common-api';

import { commonTranslationKeys, createTranslatedText, TranslatableText, Translate } from '@dreryk/react-common';
import { TextView } from '@dreryk/react-components';

type GenderTextViewProps = {
   readonly peselValue: string | null;
};

export const GenderTextView = (props: GenderTextViewProps): JSX.Element | null => {
   const text = useMemo<TranslatableText>(() => {
      if (!props.peselValue || !Pesel.isValid(props.peselValue)) {
         return createTranslatedText('-');
      }

      const gender = Pesel.of(props.peselValue).getGender();
      return `common:genderTypes.${gender.toLowerCase()}`;
   }, [props.peselValue]);

   return (
      <TextView label={commonTranslationKeys.gender} testId={'gender'}>
         <Translate>{text}</Translate>
      </TextView>
   );
};
